export enum FeatureFlags {
  WatchfulOnly = 'watchful-only',
  AdminPortal = 'admin-portal',
  MonitoringOverview = 'monitoring-overview',
  QuillAuditTool = 'quill-audit-tool',
  UltraTopSecret = 'ultra-top-secret',
  DashboardV2 = 'dashboard-v2',
  AnnouncementReporting = 'announcement-reporting',
  AutoConfig = 'auto-config',
  EdgeLink = 'edge-link-manager',
  BillingPage = 'billing-page',
  BillingEarlyAccess = 'billing-early-access',
  IntruderEvidence = 'intruder-evidence',
  AuditLogReporting = 'audit-log-reporting',
  Tagging = 'tagging',
  MultiStreamLive = 'multi-stream-live',
  IngestionViewer = 'ingestion-viewer',
}